import React from 'react';
import { ShieldCheck, Heart, Award, Users } from 'lucide-react';
export function SeoContent() {
  const features = [{
    icon: <Award className="w-6 h-6 text-brand-gold" data-id="element-94" />,
    titleZh: '历史悠久的信誉保证',
    titleEn: 'Established Reputation Since 2003',
    descZh: '自2003年成立以来，新加坡爽吧 Shiok8 一直是新加坡最值得信赖的专业Escort推荐平台。我们在芽笼 (Geylang) 及全岛范围内积累了超过20年的行业经验与良好口碑。',
    descEn: "Since 2003, Shiok8 has been Singapore's most trusted premium escort recommendation platform. We have built over 20 years of industry experience and an excellent reputation across Geylang and the entire island."
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-brand-gold" data-id="element-95" />,
    titleZh: '严格筛选的优质服务',
    titleEn: 'Premium Verified Services',
    descZh: '我们致力于为您提供最优质、最可靠的Escort服务推荐。每一位推荐的专业陪伴人员都经过严格的真实性验证，确保为您带来安全、私密且高端的陪伴体验。',
    descEn: 'We are dedicated to providing the highest quality and most reliable escort recommendations. Every professional companion is strictly verified to ensure a safe, private, and high-end experience.'
  }, {
    icon: <Users className="w-6 h-6 text-brand-gold" data-id="element-96" />,
    titleZh: '超过五万用户的选择',
    titleEn: 'Trusted by 50,000+ Users',
    descZh: '凭借4.9/5.0的高分评价和超过10,000条真实反馈，Shiok8 已经成为超过50,000名高端用户的首选。我们深知客户的需求，为您量身定制最完美的相遇。',
    descEn: 'With a 4.9/5.0 rating and over 10,000 verified reviews, Shiok8 is the preferred choice for over 50,000 premium clients. We understand your needs and tailor the perfect encounter for you.'
  }, {
    icon: <Heart className="w-6 h-6 text-brand-gold" data-id="element-97" />,
    titleZh: '繁华都市的宁静绿洲',
    titleEn: 'Your Urban Oasis',
    descZh: '无论您是寻找短暂的放松，还是深度的情感交流，新加坡爽吧都能让您在繁忙的都市生活中找到最贴心的陪伴。体验真正的新加坡Escort顶级服务。',
    descEn: 'Whether you seek brief relaxation or deep emotional connection, Shiok8 helps you find the most intimate companionship in the busy city. Experience truly top-tier Singapore Escort services.'
  }];
  return <section className="w-full bg-white py-20 lg:py-32 relative z-10 border-t border-brand-gold/10" data-id="element-98">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        {/* SEO Header */}
        <div className="text-center max-w-3xl mx-auto mb-16 lg:mb-24" data-id="element-100">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-text mb-6" data-id="element-101">
            新加坡最专业的{' '}
            <span className="text-brand-green" data-id="element-102">Escort 推荐平台</span>
          </h2>
          <p className="text-brand-muted text-lg leading-relaxed" data-id="element-103">
            Singapore's Premier Escort Recommendation Platform. Discover the
            finest companions and premium services tailored for your ultimate
            satisfaction.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-104">
          {features.map((feature, index) => <article key={index} className="bg-brand-bg/50 rounded-2xl p-8 hover:bg-brand-bg transition-colors duration-300 border border-transparent hover:border-brand-gold/20 shadow-sm hover:shadow-md" data-id="element-105">
              <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-sm mb-6" data-id="element-106">
                {feature.icon}
              </div>

              <div className="space-y-6" data-id="element-107">
                <div data-id="element-108">
                  <h3 className="text-xl font-bold text-brand-text mb-2 font-serif" data-id="element-109">
                    {feature.titleZh}
                  </h3>
                  <p className="text-brand-muted leading-relaxed text-sm sm:text-base" data-id="element-110">
                    {feature.descZh}
                  </p>
                </div>

                <div className="pt-6 border-t border-brand-gold/10" data-id="element-111">
                  <h3 className="text-lg font-semibold text-brand-green mb-2 font-serif" data-id="element-112">
                    {feature.titleEn}
                  </h3>
                  <p className="text-brand-muted/80 leading-relaxed text-sm" data-id="element-113">
                    {feature.descEn}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        {/* Bottom SEO Text Block */}
        <div className="mt-20 p-8 bg-brand-green rounded-2xl text-center" data-id="element-114">
          <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-115">
            寻找新加坡顶级陪伴服务？
          </h2>
          <p className="text-white/80 max-w-2xl mx-auto text-sm leading-relaxed" data-id="element-116">
            作为业界领先的平台，新加坡爽吧 (Shiok8)
            汇集了全岛最优质的资源。无论您身在何处，我们都能为您提供专业、安全、私密的
            Escort 推荐。立即加入我们的 Telegram 频道，获取最新资讯与专属服务。
          </p>
        </div>
      </div>
    </section>;
}